/** @format */

import styled from 'styled-components';

interface StyledModalProps {
  $isShow: boolean;
  $background: string;
  $opacity: number;
  $transition: number;
}

export const Modal = styled.div<StyledModalProps>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ $background, $opacity }) => `rgba(${$background}, ${$opacity})`};
  transition: opacity ${({ $transition }) => $transition}s, visibility ${({ $transition }) => $transition}s;
  z-index: 99;
  opacity: ${({ $isShow }) => ($isShow ? 1 : 0)};
  visibility: ${({ $isShow }) => ($isShow ? 'visible' : 'hidden')};
`;
